import {
  Directive,
  ElementRef,
  Input,
  SimpleChanges,
  OnChanges, OnDestroy,
} from '@angular/core';

@Directive({
  selector: '[scaleImgToCanvas]',
})
export class ScaleImgToCanvasDirective implements OnChanges, OnDestroy {
  @Input() scaleImgTrigger;
  @Input() scaleImgSrc;

  constructor(private element: ElementRef) {}

  img = new Image();
  target = this.element.nativeElement
  canvas = document.createElement('canvas');

  ngOnChanges(changes: SimpleChanges){
    if (changes.scaleImgTrigger) {
      this.render();
    }
  }

  ngOnDestroy() {

  }

  render() {

    if (!this.target.children.length) {
      this.img.onload = () => {
        this.target.appendChild(this.canvas);
        const ctx = this.canvas.getContext('2d');
        drawImageProp(ctx, this.img, 0, 0, 40, 40);
      };
      this.img.src = this.scaleImgSrc;
    }

    function drawImageProp(ctx, img, x, y, w, h, offsetX?, offsetY?) {

      if (arguments.length === 2) {
        x = y = 0;
        w = ctx.canvas.width;
        h = ctx.canvas.height;
      }

      // default offset is center
      offsetX = typeof offsetX === 'number' ? offsetX : 0.5;
      offsetY = typeof offsetY === 'number' ? offsetY : 0.5;

      // keep bounds [0.0, 1.0]
      if (offsetX < 0) offsetX = 0;
      if (offsetY < 0) offsetY = 0;
      if (offsetX > 1) offsetX = 1;
      if (offsetY > 1) offsetY = 1;

      var iw = img.width,
          ih = img.height,
          r = Math.min(w / iw, h / ih),
          nw = iw * r, // new prop. width
          nh = ih * r, // new prop. height
          cx,
          cy,
          cw,
          ch,
          ar = 1;

      // decide which gap to fill
      if (nw < w) ar = w / nw;
      if (Math.abs(ar - 1) < 1e-14 && nh < h) ar = h / nh; // updated
      nw *= ar;
      nh *= ar;

      // calc source rectangle
      cw = iw / (nw / w);
      ch = ih / (nh / h);

      cx = (iw - cw) * offsetX;
      cy = (ih - ch) * offsetY;

      // make sure source rectangle is valid
      if (cx < 0) cx = 0;
      if (cy < 0) cy = 0;
      if (cw > iw) cw = iw;
      if (ch > ih) ch = ih;

      // ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingEnabled = "high";
      // fill image in dest. rectangle
      ctx.drawImage(img, cx, cy, cw, ch, x, y, w, h);
    }
  }

}
